import type { ReportChartConfiguration } from '../../../../interfaces/report-chart-configuration';
import { t } from 'i18next';
import { object, string } from 'yup';
import { DefaultReportChartThemeFont, GRAPHIC_TITLE_MAX_CHAR_COUNT } from '../default-chart.config';
import { CatiChart1DeactivatedMainFilters, CatiChart1Filters } from './cati-chart1.filters';
import { CatiChart1Measures } from './cati-chart1.measures';

export const CatiChart1DefaultConfiguration: ReportChartConfiguration = {
  validationSchema: object().shape({
    selectedDate: object().shape({
      fromDate: string().required('validation:rules.generic.required'),
      toDate: string().required('validation:rules.generic.required'),
      dateRange: string().optional(),
    }),
    selectedMeasure: string().oneOf(['cati-metrics']).required('validation:rules.generic.required'),
    selectedTheme: object().shape({
      title: object().shape({
        label: string()
          .max(
            GRAPHIC_TITLE_MAX_CHAR_COUNT,
            t('validation:rules.generic.max', {
              count: GRAPHIC_TITLE_MAX_CHAR_COUNT,
            }),
          )
          .required('validation:rules.reports.selectedTheme.title.label.required'),
      }),
    }),
  }),
  measures: CatiChart1Measures,
  defaultMeasure: 'cati-metrics',
  measureReadOnly: true,
  hideCompare: true,
  filters: () => CatiChart1Filters,
  deActivateMainFilters: CatiChart1DeactivatedMainFilters,
  compareRendererComponent: null,
  customize: {
    hide: true,
    active: (values) => values.selectedMeasure === 'cati-metrics',
    limits: {
      upperLimitActive: false,
      upperLimit: 0,
      lowerLimitActive: false,
      lowerLimit: 0,
    },
    transactionalDate: {
      active: false,
    },
    feedbackCount: {
      active: false,
    },
  },
  themeComponentHide: true,
  defaultTheme: {
    active: (values) => values.selectedMeasure === 'cati-metrics',
    title: {
      ...DefaultReportChartThemeFont,
      label: '',
    },
    dataLabels: {
      ...DefaultReportChartThemeFont,
      fontBold: false,
      active: false,
      displayFormat: 'auto',
      roundingMethod: 'default',
      position: 'center',
    },
    extraSettings: {
      tableHeader: {
        ...DefaultReportChartThemeFont,
      },
    },
  },
  responseMultiple: false,
};
